import { useContext } from 'react'
import { PageContext } from '../providers'

export const usePage = () => {
  return useContext(PageContext)
}
